import React from "react";
import DonationForm from "./DonationForm";
import { ImageCluster, PinnacleFoundationLogo } from "../../components";

const Donate = () => {
  return (
    <div className="container">
      <ImageCluster />
      <div className="content-container">
        <DonationForm />
      </div>
      <div className="content-logo">
        <PinnacleFoundationLogo />
      </div>
    </div>
  );
};

export default Donate;
